module.exports = __webpack_public_path__ + "static/img/katakura_02.e48f91b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_02.jpg
// module id = QqUu
// module chunks = 0